import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { Sankey as SankeyTransform } from '../data/sankey';
import { subObject } from '../utils/helper';
import { subTooltip, maybeAnimation } from '../utils/mark';
import { field, initializeData } from './utils';
var DEFAULT_LAYOUT_OPTIONS = {
  nodeId: function nodeId(d) {
    return d.key;
  },
  nodeWidth: 0.02,
  nodePadding: 0.02
};
var DEFAULT_NODE_OPTIONS = {
  type: 'polygon',
  axis: false,
  legend: false,
  encode: {
    shape: 'polygon',
    x: 'x',
    y: 'y'
  },
  scale: {
    x: {
      type: 'identity'
    },
    y: {
      type: 'identity'
    }
  },
  style: {
    stroke: '#000'
  }
};
var DEFAULT_LINK_OPTIONS = {
  type: 'polygon',
  axis: false,
  legend: false,
  encode: {
    shape: 'ribbon',
    x: 'x',
    y: 'y'
  },
  style: {
    fillOpacity: 0.5,
    stroke: undefined
  }
};
var DEFAULT_LABEL_OPTIONS = {
  textAlign: function textAlign(d) {
    return d.x[0] < 0.5 ? 'start' : 'end';
  },
  position: function position(d) {
    return d.x[0] < 0.5 ? 'right' : 'left';
  },
  fontSize: 10
};
/**
 * @todo Add interaction
 * @todo Add source-link color mode
 */
export var Sankey = function Sankey(options) {
  var data = options.data,
    _options$encode = options.encode,
    encode = _options$encode === void 0 ? {} : _options$encode,
    scale = options.scale,
    _options$style = options.style,
    style = _options$style === void 0 ? {} : _options$style,
    _options$layout = options.layout,
    layout = _options$layout === void 0 ? {} : _options$layout,
    _options$nodeLabels = options.nodeLabels,
    nodeLabels = _options$nodeLabels === void 0 ? [] : _options$nodeLabels,
    _options$linkLabels = options.linkLabels,
    linkLabels = _options$linkLabels === void 0 ? [] : _options$linkLabels,
    _options$animate = options.animate,
    animate = _options$animate === void 0 ? {} : _options$animate,
    _options$tooltip = options.tooltip,
    tooltip = _options$tooltip === void 0 ? {} : _options$tooltip; // Initialize data, generating nodes by link if is not specified.
  var _initializeData = initializeData(data, encode),
    links = _initializeData.links,
    nodes = _initializeData.nodes; // Extract encode for node and link.
  var nodeEncode = subObject(encode, 'node');
  var linkEncode = subObject(encode, 'link');
  var _nodeEncode$key = nodeEncode.key,
    nodeKey = _nodeEncode$key === void 0 ? function (d) {
      return d.key;
    } : _nodeEncode$key,
    _nodeEncode$color = nodeEncode.color,
    color = _nodeEncode$color === void 0 ? nodeKey : _nodeEncode$color; // Transform data, using nodeKey as nodeId.
  var _SankeyTransform = SankeyTransform(Object.assign(Object.assign(Object.assign({}, DEFAULT_LAYOUT_OPTIONS), {
      nodeId: field(nodeKey)
    }), layout))({
      links: links,
      nodes: nodes
    }),
    linkData = _SankeyTransform.links,
    nodeData = _SankeyTransform.nodes; // Extract label style and apply defaults.
  var _a = subObject(style, 'label'),
    _a$text = _a.text,
    text = _a$text === void 0 ? nodeKey : _a$text,
    _a$spacing = _a.spacing,
    spacing = _a$spacing === void 0 ? 5 : _a$spacing,
    labelStyle = __rest(_a, ["text", "spacing"]);
  var key1 = field(nodeKey);
  var nodeTooltip = subTooltip(tooltip, 'node', {
    title: key1,
    items: [{
      field: 'value'
    }]
  }, true);
  var linkTooltip = subTooltip(tooltip, 'link', {
    title: '',
    items: [function (d) {
      return {
        name: 'source',
        value: key1(d.source)
      };
    }, function (d) {
      return {
        name: 'target',
        value: key1(d.target)
      };
    }]
  });
  return [deepMix({}, DEFAULT_NODE_OPTIONS, {
    data: nodeData,
    encode: Object.assign(Object.assign({}, nodeEncode), {
      color: color
    }),
    scale: scale,
    style: subObject(style, 'node'),
    labels: [Object.assign(Object.assign(Object.assign({}, DEFAULT_LABEL_OPTIONS), {
      text: text,
      dx: function dx(d) {
        return d.x[0] < 0.5 ? spacing : -spacing;
      }
    }), labelStyle)].concat(_toConsumableArray(nodeLabels)),
    tooltip: nodeTooltip,
    animate: maybeAnimation(animate, 'node'),
    axis: false
  }), deepMix({}, DEFAULT_LINK_OPTIONS, {
    data: linkData,
    encode: linkEncode,
    labels: linkLabels,
    style: Object.assign({
      fill: linkEncode.color ? undefined : '#aaa',
      strokeWidth: 0
    }, subObject(style, 'link')),
    tooltip: linkTooltip,
    animate: maybeAnimation(animate, 'link')
  })];
};
Sankey.props = {};